import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { affiliateRegisterComponent } from './affilateRegister/affilate-register.component';


const routes: Routes = [
  { path: '', component: LoginComponent},
  { path: 'affiliate-register', component: affiliateRegisterComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
